export const collision = (a, b) => {
  const ab = a.getBoundingClientRect();
  const bb = b.getBoundingClientRect();
  return !(
    ab.top + ab.height < bb.top + bb.height / 2 ||
    ab.top > bb.top + bb.height / 2
  );
};